import { CloseOutlined, CheckOutlined } from "@ant-design/icons";
import { Button, Checkbox, Col, Divider, Form, Input, Row, Space } from "antd";
import { useEffect } from "react";
import { CategoriaEmpresaModel } from "../../../../models/categoriaEmpresa/categoriaEmpresaModel";
import { atualizarCategoriaEmpresa, cadastrarCategoriaEmpresa, buscarCategoriaEmpresa } from "../../../../services/categoriaEmpresaService";
import { useAppDispatch, useAppSelector } from "../../../../util/hooks";
import { setModalCadastrarCategoriaEmpresa } from "../../../../redux/slices/categoriaEmpresa/categoriaEmpresaSlice";

type FormProps = {
  abreviacao: string;
  denominacao: string;
  exigeSorteioContaFinanceira: boolean;
};

const CadastroCategoriaEmpresaModal = () => {
  //estados globais
  const categoriaEmpresaState = useAppSelector((state) => state.categoriaEmpresa);

  //hooks
  const dispatch = useAppDispatch();

  //estados locais
  const [form] = Form.useForm<FormProps>();

  const editar = Object.values(categoriaEmpresaState.entity).length !== 0;

  useEffect(() => {
    if (editar) {
      form.setFieldsValue({ ...categoriaEmpresaState.entity });
    }
  }, [categoriaEmpresaState.entity]);

  const submit = async (values: FormProps) => {
    if (editar) {
      const args: CategoriaEmpresaModel = { id: categoriaEmpresaState.entity.id, ...values };
      dispatch(atualizarCategoriaEmpresa({ value: args }));
    } else {
      const args: CategoriaEmpresaModel = { id: null, ...values };
      dispatch(cadastrarCategoriaEmpresa({ value: args }));
    }
  };

  const voltar = () => {
    dispatch(setModalCadastrarCategoriaEmpresa(false));
  };

  return (
    <Form form={form} onFinish={submit} layout="vertical">
      <Row gutter={12}>
        <Col span={4}>
          <Form.Item
            label="Abreviação"
            name="abreviacao"
            rules={[
              {
                required: true,
                message: "Digite a Abreviação",
              },
            ]}
          >
            <Input style={{ width: "100%" }} type="text" maxLength={4} />
          </Form.Item>
        </Col>
        <Col span={20}>
          <Form.Item
            label="Denominação"
            name="denominacao"
            rules={[
              {
                required: true,
                message: "Digite a Denominação",
              },
            ]}
          >
            <Input style={{ width: "100%" }} type="text" maxLength={20} />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col>
          <Form.Item
            //label="Exigir sorteio na conta financeira"
            name="exigeSorteioContaFinanceira"
            valuePropName="checked"
          >
            <Checkbox>Exigir sorteio na conta financeira</Checkbox>
          </Form.Item>
        </Col>
      </Row>
      <Divider />
      <Row gutter={12}>
        <Col span={24} className="modalFooter">
          <Space size="middle">
            <Button className="cancelButton" onClick={voltar} icon={<CloseOutlined />}>
              FECHAR
            </Button>
            <Button htmlType="submit" icon={<CheckOutlined />} className="buttonPrimary">
              {editar ? "ATUALIZAR" : "SALVAR"}
            </Button>
          </Space>
        </Col>
      </Row>
    </Form>
  );
};
export default CadastroCategoriaEmpresaModal;
